import { render, staticRenderFns } from "./allocate.vue?vue&type=template&id=48b37151&"
import script from "./allocate.vue?vue&type=script&lang=js&"
export * from "./allocate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports